module.exports = __webpack_public_path__ + "static/img/portrait.97de32f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portrait.png
// module id = 3wUI
// module chunks = 52